export default "__VITE_ASSET__CTsAEAbm__"